import { type BaseBarcodeTemplateRepository } from "../../_Bases/BaseBarcodeTemplateRepository";
import { type LocalDatabaseBarcodeTemplate } from "../../_Bases/BaseBarcodeTemplateRepository";
import { type InternalIndexedDBDatabase } from "../../DataStores/Database";
import BaseIndexedDBRepository from "../../Implementations/BaseIndexedDBRepository";

export default class IndexedDBBarcodeTemplateRepository extends BaseIndexedDBRepository<
    LocalDatabaseBarcodeTemplate,
    number
> implements BaseBarcodeTemplateRepository {
    public readonly source: InternalIndexedDBDatabase["barcodeTemplates"];
    protected readonly dataTypeName = "Barcode Template";

    constructor(source: InternalIndexedDBDatabase) {
        super();

        this.source = source.barcodeTemplates;
    }
}
